import { render, staticRenderFns } from "./word_search.vue?vue&type=template&id=b136db28&scoped=true&"
import script from "./word_search.vue?vue&type=script&lang=js&"
export * from "./word_search.vue?vue&type=script&lang=js&"
import style0 from "./word_search.vue?vue&type=style&index=0&id=b136db28&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b136db28",
  null
  
)

export default component.exports